import { Link } from 'react-router-dom';
import { ENGINE_BUILD } from '../engine/config';

interface Component {
  name: string;
  version: string;
  license: string;
  role: string;
  source: string;
  notice: string;
}

/**
 * Third-party notices (specification §1.3, R-17).
 *
 * Chessground and Stockfish are GPL-3.0-or-later, and this SPA *conveys* both to the
 * browser — Chessground in the bundle, Stockfish as the WASM engine served from
 * `/engine`. That makes the notices, the pinned versions and a route to corresponding
 * source a distribution obligation rather than a courtesy.
 *
 * The notice files are vendored next to the artifacts by `npm run vendor:engine`; a
 * build that skipped that step serves no engine either, so the links degrade together.
 */
const COMPONENTS: Component[] = [
  {
    name: 'Stockfish',
    version: `18 (${ENGINE_BUILD})`,
    license: 'GPL-3.0-or-later',
    role: 'Chess engine. Runs in your browser as WebAssembly for local analysis, and on the server for shared evaluations.',
    source: 'https://github.com/nmrugg/stockfish.js',
    notice: '/licenses/stockfish-COPYING.txt',
  },
  {
    name: 'Chessground',
    version: '10.1.1',
    license: 'GPL-3.0-or-later',
    role: 'Board renderer.',
    source: 'https://github.com/lichess-org/chessground',
    notice: '/licenses/chessground-LICENSE.txt',
  },
];

export function Licenses(): JSX.Element {
  return (
    <main className="page licenses-page">
      <section className="panel" aria-labelledby="licenses-title">
        <h1 id="licenses-title">Third-party notices</h1>
        <p>
          ItsAllPrep includes the following GPL-licensed components. Each is distributed
          under its own license, whose full text is linked below, and corresponding source
          is available at the pinned version.
        </p>
        <dl className="license-list">
          {COMPONENTS.map((component) => (
            <div key={component.name} className="license-entry">
              <dt>
                {component.name} {component.version}
              </dt>
              <dd>
                <p>{component.role}</p>
                <p className="muted">{component.license}</p>
                <p>
                  <a href={component.source} rel="noreferrer noopener" target="_blank">
                    Source
                  </a>
                  {' · '}
                  <a href={component.notice} rel="noreferrer noopener" target="_blank">
                    License text
                  </a>
                </p>
              </dd>
            </div>
          ))}
        </dl>
        <p>
          <Link to="/">Back to your repertoires</Link>
        </p>
      </section>
    </main>
  );
}
